module.exports = {
      id: "comm-news-usage",
      viewBox: "0 0 223.506 38.837",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#comm-news",
      toString: function () {
        return this.url;
      }
    }